import { StoreThunk } from "@green24/npm-preact-utils/store";
import { locationActions } from "../actions/actions";
import { locationServices } from "../../services/location-services";

export class Thunk_Location extends StoreThunk {
	getLocation(locationID, background = false) {
		this.dispatch(background ? locationActions.getBackgroundFetchPending() : locationActions.getFetchPending());

		return new Promise((resolve, reject) => {
			locationServices.getItem(locationID).then(location => {
				this.dispatch(locationActions.getFetchFulfilled(location));
				resolve(location);
			}, res => {
				this.dispatch(locationActions.getFetchRejected(res));
				reject(res);
			});
		});
	}

	clearLocation() {
		this.dispatch(locationActions.getItemClear());
	}
}
